<template>

  <div class="animated fadeIn">
    <b-card no-body>
      <b-row>
        <b-col cols="10" class="ml-2">
          <h2>Selected Satsangi: {{getSatsangiName()}}</h2>
        </b-col>
        <b-col class="m-2" no-gutters>
          <b-button v-b-toggle.catsidebar class="ml-1" variant="info">Categories</b-button>
      </b-col>
      </b-row>
    </b-card>

    <b-row>
      <b-col>
        <sale-option-buttons @deleteLine="deleteProduct"
                             @newSale="newSale(true)"
                             @retrieveParkedSale="retrieveParkedSale"
                             @parkSale="parkSale"
                             @searchSatsangi="searchSatsangi"
                             @editLineItem="editSelectedProduct"
                             @payments="submitPayments"
                             @printReceipt="reprintReceipt"
                            />
        <b-button @click="editFromToDate" class="ml-1" variant="info">Change Meal Dates</b-button>
      </b-col>
    </b-row>
    <b-card no-body>
      <b-row>
        <b-col>
          <sale-ticket-items
            :systemid="systemid"
            @processpayment="processPayment" @qtyChanged="qtyChanged" @product-by-barcode="productSelected"
            ref="ticketItemsTab"></sale-ticket-items>
        </b-col>
      </b-row>
    </b-card>
    <b-row>
      <b-col>
        <b-sidebar id="catsidebar" title="Categories and Products" shadow width="500px">
          <category-product-panel :systemid="systemid" @productSelected="productSelected" @updated="setFocus"></category-product-panel>
        </b-sidebar>
      </b-col>
    </b-row>
    <div>
      <b-modal ref="modalSearchSatsangi"
               title="Search Satsangi"
               hide-footer
               @hide="hideSearchSatsangiModal"
               no-enforce-focus
               no-close-on-backdrop
               centered
               size="lg">
        <search-satsangi-modal @success="searchSatsangiSuccess" @cancel="cancelSearchSatsangi" />
      </b-modal>
    </div>
    <div>
      <b-modal ref="modalVariablePriceQty"
               title="Variable Bhent and Quantity"
               hide-footer
               no-enforce-focus
               no-close-on-backdrop
               centered
               size="lg">
        <variable-prd-price-modal @success="acceptVariablePriceQty" @cancel="cancelVariablePriceQty" :product="editProduct" />
      </b-modal>
    </div>
    <div>
      <b-modal ref="modalFromToDates"
               title="Meal From and To Date"
               hide-footer
               no-enforce-focus
               no-close-on-backdrop
               centered
               size="lg">
        <from-to-date-prd-modal @updatesuccess="acceptUpdatePrdFromToDate" @success="acceptPrdFromToDate" @cancel="cancelPrdFromToDate" :product="fromToDateProduct" />
      </b-modal>
    </div>
  </div>

</template>
<script>

  import Vue from 'vue'
  import CategoryProductPanel from './CategoryProductPanel'
  import SaleTicketItems from './components/SaleTicketItems'
  import SaleOptionButtons from './components/SaleOptionButtons'
  import SearchSatsangiModal from './components/SearchSatsangiModal'
  import VariablePrdPriceModal from './components/VariablePrdPriceModal'
  import FromToDatePrdModal from './components/FromToDatePrdModal'
  import filter from 'lodash/filter'

  const receiptShape = {
    receiptType: "bhandarghar",
    products: null,
    ticketid: null,
    cardno: null
  }

  export default {
    name: 'BhandarGharPos',
    components: {
      'category-product-panel': CategoryProductPanel,
      'sale-ticket-items': SaleTicketItems,
      'sale-option-buttons': SaleOptionButtons,
      'search-satsangi-modal': SearchSatsangiModal,
      'variable-prd-price-modal': VariablePrdPriceModal,
      'from-to-date-prd-modal': FromToDatePrdModal

    },
    data: function() {
      return {
        selecetdSatsangi: null,
        editProduct: null,
        systemid: '3',
        showConfirmMsg: false,
        receipt: Object.assign({}, receiptShape),
        fromToDateProduct: null

      }
    },
    computed: {
      getBhaintCategories(){
        return filter(this.$store.state.pos.bhaintPrasadCategories,
           function(cat) {
             return (cat.isbhaint == true);
           });
      },
      getPrasadCategories(){
        return filter(this.$store.state.pos.bhaintPrasadCategories,
           function(cat) {
             return (cat.isprasad == true);
           });
      },
      getMealCategories(){
        return filter(this.$store.state.pos.bhaintPrasadCategories,
           function(cat) {
             return (cat.ismeal == true);
           });
      },
    },
    methods: {
      submitPayments(){
        if(this.$refs.ticketItemsTab.getLineItemsSize() > 0){
          this.$refs.ticketItemsTab.submitCash();
        }
        else {
          this.showErrorMsg({
            message:
              'Please select products for sale before clicking Payments option.'
          })
        }

      },
      acceptVariablePriceQty(product) {
        console.log(product)
        this.$refs.modalVariablePriceQty.hide()
        var selectedProduct = JSON.parse(JSON.stringify(product))
        if (this.checkCardScanned(selectedProduct, false)) {
          this.$refs.ticketItemsTab.priceQtyChanged(selectedProduct)
        }else{
          this.$refs.ticketItemsTab.priceQtyChanged(null);
        }
      },
      cancelVariablePriceQty() {
        this.$refs.modalVariablePriceQty.hide()
      },
      editFromToDate(){
        var productSelectedToEdited = this.$refs.ticketItemsTab.getProductToBeEdited()

        if (productSelectedToEdited != null) {
          if(this.checkMealCategory(productSelectedToEdited.categoryId) == true){
            this.fromToDateProduct = JSON.parse(JSON.stringify(productSelectedToEdited));
            this.fromToDateProduct.updateDates = true;
            this.$refs.modalFromToDates.show();
          }
          else{
            this.showErrorMsg({
              message:
                'Selected product is not meal type product. Can not set From and To Date for non Meal Type products. (चयनित उत्पाद भोजन प्रकार का उत्पाद नहीं है। गैर भोजन प्रकार के उत्पादों के लिए तिथियां निर्धारित नहीं कर सकते).'
            })
          }

        } else {
          this.showErrorMsg({
            message:
              'Please select the Transaction Line Item to change first. (बदलने के लिए कृपया पहले लेन-देन लाइन आइटम का चयन करें).'
          })
        }
      },
      editSelectedProduct() {
        var productSelectedToEdited = this.$refs.ticketItemsTab.getProductToBeEdited()
        if (productSelectedToEdited != null) {
          this.editProduct = JSON.parse(JSON.stringify(productSelectedToEdited))
          this.$refs.modalVariablePriceQty.show()
        } else {
          this.showErrorMsg({
            message:
              'Please select the Transaction Line Item to change first. (बदलने के लिए कृपया पहले लेन-देन लाइन आइटम का चयन करें).'
          })
        }
      },
      getSatsangiName() {
        if (this.selecetdSatsangi != null && Object.keys(this.selecetdSatsangi).length > 0) {
          return this.selecetdSatsangi.name
        } else {
          return 'None'
        }
      },
      checkMealCategory(catId){
        console.log('cat id to check');
        console.log(catId);
          let categoriesId = this.getMealCategories;
          console.log(categoriesId);
          var found = categoriesId.filter(function(item) {
            return item.categoryId == catId
          });

          return (found != null && found.length > 0);
      },
      checkBhentOrPrasadCategory(catId, isBhent) {
        let categoriesId;
        if (isBhent) {
          // Todo: Get Bhent Category from backend. Hardcoded for now
          categoriesId = this.getBhaintCategories;

        } else {
          // Todo: Get Prasad Category from backend. Hardcoded for now
          categoriesId = this.getPrasadCategories;

        }

        var found = categoriesId.filter(function(item) {
          return item.categoryId == catId
        });

        return (found != null && found.length > 0);
      },
      checkCardScanned(product, isAddNew) {
        let hasCardLine = false

        if (
          product.categoryId != null &&
          isAddNew == true &&
          this.checkBhentOrPrasadCategory(product.categoryId, true) == true
        ) {
          if (this.selecetdSatsangi != null && Object.keys(this.selecetdSatsangi).length > 0) {
            hasCardLine = true
          }
          if (!hasCardLine) {
            this.showErrorMsg({
              message:
                'Please scan Satsangi Card before accepting Bhaint.'
            })
          }
        }
        else {
          hasCardLine = true;
        }
        return hasCardLine
      },
      qtyChanged(productQtyIncrease) {
        if (this.checkCardScanned(productQtyIncrease.product, false)) {
          this.$refs.ticketItemsTab.changeProductQty(productQtyIncrease.index, true, productQtyIncrease.product.qty)
        } else {
          this.$refs.ticketItemsTab.changeProductQty(productQtyIncrease.index, false, productQtyIncrease.origQty)
        }
      },
      acceptUpdatePrdFromToDate(product){
        var selectedProduct = JSON.parse(JSON.stringify(product));
        if (this.checkCardScanned(selectedProduct, true)) {
            this.$refs.ticketItemsTab.updateSelectedProductDates(selectedProduct)
        }
        else{
          this.$refs.ticketItemsTab.updateSelectedProductDates(null)
        }
        this.$refs.ticketItemsTab.setBarcodeInputFocus()
        this.$refs.modalFromToDates.hide();
        this.fromToDateProduct = null;
      },
      acceptPrdFromToDate(product){
        var selectedProduct = JSON.parse(JSON.stringify(product));
        if (this.checkCardScanned(selectedProduct, true)) {
            this.$refs.ticketItemsTab.addProduct(selectedProduct)
            this.$refs.ticketItemsTab.setBarcodeInputFocus()
            this.$refs.modalFromToDates.hide();
            this.fromToDateProduct = null;
        }
      },
      cancelPrdFromToDate() {
        this.$refs.modalFromToDates.hide();
        this.fromToDateProduct = null;
      },
      isOverLaped(newStart,Newend,oldStart,oldEnd){

        var tempNewStart = new Date(newStart);
        var tempNewEnd = new Date(Newend);
        var tempOldStart = new Date(oldStart);
        var tempOldEnd = new Date(oldEnd);
        if (
            (newStart > oldStart && newStart < oldEnd) ||
            (oldStart > newStart && oldStart < Newend) ||
            (newStart < oldStart && Newend > oldEnd) ||
            (tempNewStart.getTime() == tempOldStart.getTime() || tempNewStart.getTime() == tempOldEnd.getTime()
              || tempNewEnd.getTime() == tempOldStart.getTime() || tempNewEnd.getTime() == tempOldEnd.getTime() )
            )
        {
            return true;
        } else {
            return false;
        }
      },

      checkMealDatesForUpdate(product){
        const selectedProducts = this.$refs.ticketItemsTab.getProductsSelected();
        let returnValue = false;
        if (selectedProducts != null) {
          let tempThis = this
          selectedProducts.forEach(function(prd) {
            if (tempThis.checkMealCategory(prd.categoryId) == true && product.id === prd.id && prd.isEditing != true) {
                let isOverlap = tempThis.isOverLaped(product.fromdate, product.todate,prd.fromdate, prd.todate);
                if(isOverlap == true){
                  returnValue = true;
                  tempThis.showErrorMsg({
                    message:
                      'Dates overlap for Meal type selected. Please choose different dates.(भोजन प्रकार के लिए तिथियां ओवरलैप होती हैं। कृपया अलग तिथियां चुनें।)'
                  })
                  return false;
                }

            }
          })
        }
        return returnValue;
      },
      checkMealDates(product){
        const selectedProducts = this.$refs.ticketItemsTab.getProductsSelected();
        let returnValue = false;
        if (selectedProducts != null) {
          let tempThis = this
          selectedProducts.forEach(function(prd) {
            if (tempThis.checkMealCategory(prd.categoryId) == true && product.id === prd.id) {
                let isOverlap = tempThis.isOverLaped(product.fromdate, product.todate,prd.fromdate, prd.todate);
                if(isOverlap == true){
                  returnValue = true;
                  tempThis.showErrorMsg({
                    message:
                      'Dates overlap for Meal type selected. Please choose different dates.(भोजन प्रकार के लिए तिथियां ओवरलैप होती हैं। कृपया अलग तिथियां चुनें।)'
                  })
                  return false;
                }

            }
          })
        }
        return returnValue;
      },
      productSelected(product) {
        if(this.checkMealCategory(product.categoryId) == true){
            this.fromToDateProduct = JSON.parse(JSON.stringify(product));
            this.$refs.modalFromToDates.show();
        }
        else{
          if (this.checkCardScanned(product, true)) {
              this.$refs.ticketItemsTab.addProduct(product)
              this.$refs.ticketItemsTab.setBarcodeInputFocus()
          }
        }
      },
      deleteProduct() {
          this.$refs.ticketItemsTab.deleteProduct()
          this.$refs.ticketItemsTab.setBarcodeInputFocus()
      },
      newSale(showMsg) {
        this.$refs.ticketItemsTab.deleteAllProducts(showMsg);
        this.$refs.ticketItemsTab.setBarcodeInputFocus();
        this.selecetdSatsangi = null;

      },
      async reprintReceipt(){
        if(this.receipt == null || this.receipt.ticketid == null || this.receipt.products == null){
          this.showErrorMsg({
            message: "No last receipt to print."
          });
        }
        else{
          await this.callReceiptService();
        }

      },
      async printReceipt(data){

        this.receipt.receiptType = this.receipt.receiptType
        this.receipt.products = data.products
        this.receipt.ticketid = data.ticketid
        this.receipt.cardno = data.cardno

        await this.callReceiptService();
      },
      callReceiptService(){
        this.$nextTick(() => {
         let params = JSON.stringify(this.receipt);
         console.log(params);
         this.$store.dispatch('pos/printReceipt', params)
           .then((response) => {
             console.log(response.data.status);
             if(response.data.status == 'error'){
                 if(response.data.message != null){
                   this.showErrorMsg({
                   message: "Print Failed: " + response.data.message
                 });
                 }
                 else{
                   this.showErrorMsg({
                     message: "Print Failed. Please check Print service is running."
                   });
                 }
               }
               else{
                 this.showErrorMsg({
                   message: "Receipt Printed successfully."
                 });
               }
           })
           .catch((error) => {
             if(error.response != null && error.response.data.message != null){
               this.showErrorMsg({
                 message: "Print Failed: " + error.response.data.message
               });
             }
             else{
               this.showErrorMsg({
                 message: "Print Failed. Please check Print service is running."
               });
             }



           })
     });

     },
      processPayment(params){
        console.log('Start Payment Process');
        params.customer = this.selecetdSatsangi;
        params.session =  this.$store.state.pos.userSession;
        params.systemid = this.systemid;
        let sale = {bhandargharsale: params};
        console.log(sale);
        console.log('End Payment Process');
        this.$store.dispatch('pos/createBhandargharTicket', params)
         .then(response => {
           if (response.data.success == false) {
             this.showErrorMsg({
               message: response.data.error
             })
           } else {
             this.showSuccessMsg({
               message: 'Ticket Created successfully.'
             });
             this.newSale(false);
             if(response.data.data.cardno == null){
               this.printReceipt(response.data.data)
             }


           }


         })
         .catch(error => {
           console.log(error);
           if (error.response.status == 400) {
             this.showErrorMsg({
               message: error.response.data.message
             })
           }
           else if (error.response.status == 422){
               this.showErrorMsg({
                 message: error.response.data.message
               });

           }
           else {
             this.showErrorMsg({message: "Something went wrong when fetching Bhaint and Prasad categories. Please contact administrator."})
           }
         });

      },
      parkSale() {
        this.$refs.ticketItemsTab.parkSale()
        this.$refs.ticketItemsTab.setBarcodeInputFocus()
      },
      retrieveParkedSale() {
        this.$refs.ticketItemsTab.retrieveParkedSale()
        this.$refs.ticketItemsTab.setBarcodeInputFocus()
      },
      setFocus() {
        this.$refs.ticketItemsTab.setBarcodeInputFocus()
      },
      searchSatsangi() {
        if (!this.checkBhentTrasactionExists()) {
          this.$refs.modalSearchSatsangi.show()
        }
      },
      checkBhentTrasactionExists() {
        var returnValue = false
        const selectedProducts = this.$refs.ticketItemsTab.getProductsSelected()

        if (selectedProducts != null) {
          for (let i = 0; i < selectedProducts.length; i++) {
            var line = selectedProducts[i]
            if (this.checkBhentOrPrasadCategory(line.categoryId, true)) {
              returnValue = true
              this.showErrorMsg({
                message:
                  'Please remove Bhaint transactions before removing/changing the Satsangi card. (सत्संगी का कॉर्ड चेंज करने से पहले, कृपया पहले भेंट ट्रेन्ज़ेक्शन को डिलीट करें).'
              })
              break
            }
          }
        }

        return returnValue
      },
      searchSatsangiSuccess(foundSatsangi) {
        this.selecetdSatsangi = foundSatsangi
        console.log(this.selecetdSatsangi)
        this.$refs.modalSearchSatsangi.hide()
        this.setFocus()
      },
      cancelSearchSatsangi() {
        this.$refs.modalSearchSatsangi.hide()
        this.setFocus()
      },
      hideSearchSatsangiModal() {
        this.setFocus()
      }
    },
    mounted: function() {
      this.$refs.ticketItemsTab.setBarcodeInputFocus()
    },
    created: function(){
      if (this.$store.state.pos.bhaintPrasadCategories.length == 0) {
        let params = {
          systemid: this.systemid
        }
        this.$store.dispatch('pos/getBhainPrasadCategories', params)
        .catch(error => {

          if (error.response.status == 400) {
            this.showErrorMsg({
              message: error.response.data.message
            })
          }
          else if (error.response.status == 422){
              this.showErrorMsg({
                message: error.response.data.message
              });

          }
          else {
            this.showErrorMsg({message: "Something went wrong when fetching Bhaint and Prasad categories. Please contact administrator."})
          }
        });
      }
      if (this.$store.state.pos.userSession == null || this.$store.state.pos.userSession.length == 0) {
        let params = {
          systemid: this.systemid
        }
        this.$store.dispatch('pos/createUserSession', params)
        .catch(error => {
            console.log('Error While creating Session');
            console.log(error);
            console.log('Finish Logs for Session Creation Error');
        });
      }
    }
  }

</script>
